import styled from "styled-components";

const ApplicationClosedSectionWrapper = styled.div`
  width: 100%;
  max-width: 455px;
  margin: 0 auto;
  padding: 150px 25px 100px 25px;
  position: relative;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  z-index: 1;

  h5 {
    font-family: "new-order", sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 47px;
    text-transform: uppercase;
  }

  span {
    font-family: Neue-Haas, sans-serif;
    font-weight: 400;
    size: 16px;
    line-height: 26px;
    color: #cecfd0;
  }

  @media ${({ theme }) => theme.mediaQueries.bellowTabletProtrait} {
    h5 {
      font-size: 20px;
      line-height: 33px;
    }
  }
`;

const ApplicationClosed: React.FC = () => {
  return (
    <ApplicationClosedSectionWrapper id="application">
      <h5>2023 Applications</h5>
      <span>2023 Applications are now closed. Check back early next year to apply for 2024 Cohort.</span>
    </ApplicationClosedSectionWrapper>
  );
};

export default ApplicationClosed;
